import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar.tsx";
import { Button } from "@/components/ui/button.tsx";
import { RoleBadge } from "@/components/users/role-badge.tsx";
import { User } from "@/lib/api/user.ts";
import { getInitials } from "@/lib/utils.ts";
import { getPrimaryRole } from "@/lib/utils/system-roles";
import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { useRouter } from "@tanstack/react-router";
import { format } from "date-fns";

interface HeaderProps {
  user: User;
}

export function Header({ user }: HeaderProps) {
  const router = useRouter();
  const { profile_picture_url: profilePhoto, name } = user;

  return (
    <div className="flex flex-row items-center justify-between gap-2 border-b pb-3">
      <div className="flex flex-row items-center gap-2">
        <Button
          size="icon"
          variant="ghost"
          onClick={() => {
            router.history.back();
          }}
        >
          <ChevronLeftIcon className="h-6 w-6" />
        </Button>

        <div className="flex items-center gap-2">
          <Avatar className="h-10 w-10">
            <AvatarImage src={profilePhoto ?? undefined} alt={name ?? ""} />
            <AvatarFallback className="text-xs">
              {getInitials(name ?? undefined)}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col gap-1">
            <div className="font-bold">{name}</div>
            <div className="flex flex-row items-center gap-2">
              <RoleBadge role={getPrimaryRole(user.systemRoles)} size="sm" />
              <div className="text-xs font-normal italic leading-tight text-zinc-600">
                Started on {format(new Date(user.created_at), "MMM dd, yyyy")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
